// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4101":"c478824600214b64","7932":"15526bd2f429a657"}[chunkId] + ".css";
};